export default "__VITE_ASSET__DOkYPu7Y__"